module.exports = __webpack_public_path__ + "static/Charity-Governance-Award-fd6e5cf2615f87d05dbb406dd81ea928.jpg";